import React from 'react'
import links from 'links'
import cx from 'classnames'
import { useDevice } from 'device'
import { useModuleTitle } from 'models/settings'

import HeaderButton from 'src/components/inputs/buttons/HeaderButton/HeaderButton'

import { Href } from 'components/navigation'
import { Text } from 'components/dataDisplay'

import medscanLogoImage from './images/medscan_logo.png'
import medscanImage from './images/medscan_picture.png'


type MedscanBlockProps = {
  className?: string
}

const MedscanBlock: React.FC<MedscanBlockProps> = (props) => {
  const { className } = props
  const { isMobile } = useDevice()

  const linkToMedscan = links.medscan.root

  const { title: moduleTitle } = useModuleTitle('MED_ASSIST')
  return (
    <div className={cx(className)}>
      <HeaderButton
        title={moduleTitle}
        size={isMobile ? 'h20-24' : 'h32'}
        to={linkToMedscan}
      />
      <Text
        className="mt-16px opacity-64"
        message="Профессиональная медицинская помощь взрослым и детям в ведущем лечебном учреждении города"
        size="t16-24"
        color="gladiator"
      />
      <Href to={linkToMedscan}>
        <div
          className="mt-32px flex justify-between bg-trainspotting radius-24 overflow-hidden relative pointer"
          style={{
            height: `280px`,
            backgroundImage: `linear-gradient(95.83deg, #F5F6F8 26.77%, rgba(245, 246, 248, 0) 61.27%), url(${medscanImage})`,
            backgroundPositionX: 'right',
          }}
        >
          <div className="flex flex-col justify-between ml-32px my-32px" style={{ width: '200px' }}>
            <Text
              message={`2000 видов услуг по 120 направлениям, современное оборудование, многопрофильный стационар, работа с программами ДМС`}
              size="s13-r"
              color="titanic"
            />
            <img srcSet={medscanLogoImage + ' 2x'} width="169" height="44" alt="icon" />
          </div>
        </div>
      </Href>
    </div>
  )
}

export default MedscanBlock